import React from "react"
import { DeepReadonly } from "ts-essentials"
import AnalyticsContext, { useAnalyticsWithProperties } from "connected-components/analytics/context"
import { useAssetViewAnalyticsProperties } from "./use-analytics-properties"

interface AssetViewAnalyticsProviderProps {
  children: React.ReactNode
}

/**
 * Provides asset view analytics context with automatic property extraction
 * and "Asset View" prefix for all events.
 *
 * This provider wraps children with analytics context that includes:
 * - Asset view-specific context properties (viewId, groupBy, etc.)
 * - "Asset View" prefix for all tracked events
 * - Inheritance from parent analytics contexts if nested (Dashboard properties)
 *
 */
export function AssetViewAnalyticsProvider({
  children,
}: DeepReadonly<AssetViewAnalyticsProviderProps>) {
  const contextProperties = useAssetViewAnalyticsProperties()

  const analyticsContextValue = useAnalyticsWithProperties(contextProperties, "Asset View")

  return (
    <AnalyticsContext.Provider value={analyticsContextValue}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default AssetViewAnalyticsProvider
